<app-walkthrough-slide>
  <div copy class="wt-eyebrow">{{ 'app.pages.auth.walkthrough.pane2.eyebrow' | translate }}</div>
  <h2 copy class="wt-h2">{{ 'app.pages.auth.walkthrough.pane2.title' | translate }}</h2>
  <p copy class="wt-p">{{ 'app.pages.auth.walkthrough.pane2.body' | translate }}</p>

  <div copy class="wt-bul">
    <div class="wt-bul__i">
      <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane2.bullet.sectors' | translate }}</span>
    </div>
    <div class="wt-bul__i">
      <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane2.bullet.oneLogin' | translate }}</span>
    </div>
    <div class="wt-bul__i">
      <ion-icon name="checkmark-circle" aria-hidden="true"></ion-icon>
      <span>{{ 'app.pages.auth.walkthrough.pane2.bullet.tested' | translate }}</span>
    </div>
  </div>

  <!-- Four module tiles. Inert: `<div>`, no handler (§12 #16). -->
  <div viz class="vgrid">
    @for (tile of tiles; track tile.labelKey) {
      <div class="vmod">
        <ion-icon [name]="tile.icon" aria-hidden="true"></ion-icon>
        <span>{{ tile.labelKey | translate }}</span>
      </div>
    }
  </div>

  <!-- …and the one thing underneath all four. -->
  <div viz class="vnode vnode--summary">
    <span class="vnode__b vnode__b--solid">
      <ion-icon name="layers-outline" aria-hidden="true"></ion-icon>
    </span>
    <span>{{ 'app.pages.auth.walkthrough.pane2.summary' | translate }}</span>
  </div>
</app-walkthrough-slide>
